import React from 'react';
import venmoWhiteLogo from '../../assets/venmo-white.png';
import styles from './SubmitBtn.module.css';

interface VenmoButtonProps {
  handleVenmo: () => void;
  disabled: boolean;
}

const VenmoButton: React.FunctionComponent<VenmoButtonProps> = ({ handleVenmo, disabled }) => (
  <button type="button" onClick={handleVenmo} className={styles.venmo} disabled={disabled}>
    <img src={venmoWhiteLogo} alt="Check Out with Venmo" />
  </button>
);

export default VenmoButton;
